module.exports = __webpack_public_path__ + "img/github.446333a2.png";